import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';

import Contacts from './components/Contacts';
import Application from './components/Application';
import SubmitButton from './components/SubmitButton';
import ErrorNotification from './components/ErrorNotification';
import SuccessNotification from './components/SuccessNotification';

class ContactForm extends React.Component {
    state = {
        form: {
            name: '',
            contactPerson: '',
            tel: '',
            email: '',
            format: 'stand',
            address: '',
            website: '',
            promo: '',
            boothNumber: ''
        },
        isSubmitDisabled: false,
        isLoading: false,
        showForm: true,
        showSuccess: false,
        showError: false,
        application: null,
    };

    render() {
        const {
            form,
            showSuccess,
            showError,
            showForm,
            isLoading,
        } = this.state;
        const { intl } = this.props;

        if (showSuccess) {
            return <SuccessNotification />;
        }

        return (
            <div style={{ marginTop: '2rem' }}>
                {showForm && (
                    <div>
                        <h5 className="title is-5">
                            <FormattedMessage id="exhibitApplication.formTitle" />
                        </h5>
                        <Contacts
                            intl={intl}
                            form={form}
                            onChange={this.handleChange}
                            style={{ marginBottom: '2rem' }}
                        />
                        <hr />
                        <Application onChange={this.handleApplicationChange} />
                        <div className="notification">
                            <FormattedMessage
                                id="exhibitApplication.comment"
                                tagName="p"
                            />
                        </div>
                        {showError && (
                            <ErrorNotification
                                onClose={this.hideErrorMessage}
                            />
                        )}
                        <div className="is-flex">
                            <SubmitButton
                                onClick={this.handleSubmit}
                                disabled={this.isSubmitDisabled()}
                                isLoading={isLoading}
                                style={{
                                    marginTop: '2rem',
                                    marginLeft: 'auto',
                                }}
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }

    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({ form: { ...this.state.form, [name]: value } });
    };

    handleSubmit = () => {
        this.setState({
            isSubmitDisabled: true,
            isLoading: true,
            showError: false,
        });

        let error = false;

        this.sendApplication()
            .then((response) => {
                if (response.ok) {
                    this.setState({
                        showSuccess: true,
                        showForm: false,
                        isLoading: false,
                    });
                } else {
                    error = true;
                    this.setState({
                        showError: true,
                        isSubmitDisabled: false,
                        isLoading: false,
                    });
                }
                return response.text();
            })
            .then((data) => error && console.log(data))
            .catch((err) => {
                this.setState({
                    showError: true,
                    isSubmitDisabled: false,
                    isLoading: false,
                });
                console.log(err);
            });
    };

    sendApplication = () => {
        const { form, application } = this.state;
        return fetch('/.netlify/functions/exhibitApplication', {
            method: 'post',
            body: JSON.stringify({
                contacts: form,
                application,
            }),
        });
    };

    isSubmitDisabled = () => {
        const { form, application, isSubmitDisabled } = this.state;
        return (
            isSubmitDisabled ||
            // !!Object.keys(form).filter((key) => !form[key]).length ||
            !application ||
            !application.services.length
        );
    };

    handleApplicationChange = (application) => {
        console.log(application);
        this.setState({
            application,
        });
    };
}

export default injectIntl(ContactForm);



// WEBPACK FOOTER //
// ./src/components/ContactForm/index.js